// Shared helpers for displaying lead source / category metadata.
// Used by the Thank You page and the admin submissions view so labels
// stay in sync across the app.

export const LEAD_SOURCE_LABELS: Record<string, string> = {
  website_form: "Website Form",
  whatsapp_fallback: "WhatsApp Fallback",
  whatsapp_float: "WhatsApp Floating Button",
  whatsapp_thankyou: "WhatsApp (Thank You)",
};

export function humanizeLeadSource(source?: string | null): string {
  if (!source) return "—";
  return LEAD_SOURCE_LABELS[source] ?? source.replace(/[_-]+/g, " ");
}

export const CATEGORY_LABELS: Record<string, string> = {
  electrical: "Electrical Products",
  sanitary: "Sanitary Products",
  "iron-and-steel": "Iron & Steel",
  tiles: "Tiles",
  hardware: "Hardware",
  other: "Other / Multiple",
};

export function humanizeCategory(slug?: string | null): string {
  if (!slug) return "—";
  return CATEGORY_LABELS[slug] ?? slug.replace(/[_-]+/g, " ");
}
